import axios from 'axios';
import { API_URL } from '../config';

export const login = async (data: any) => {
	const URL = `${API_URL}LoginDetails`;
	const requestData = {
		LoginDetailsToken: data,
	};
	return axios.post(URL, requestData, { headers: { 'Content-Type': 'application/json' } });
};
